// Generated by purs version 0.15.10
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_BigInt from "../Data.BigInt/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as MST_Data_Time from "../MST.Data.Time/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var add1 = /* #__PURE__ */ Data_Semiring.add(Data_BigInt.semiringBigInt);
var zero = /* #__PURE__ */ Data_Semiring.zero(Data_BigInt.semiringBigInt);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordNumber);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Data_BigInt.eqBigInt);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_BigInt.ordBigInt);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString);
var decodeJson1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonNumber);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Test_QuickCheck_Gen.functorGen);
var arbitrary = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbInt);
var mul1 = /* #__PURE__ */ Data_Semiring.mul(Data_BigInt.semiringBigInt);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Data_BigInt.ordBigInt);
var sub = /* #__PURE__ */ Data_Ring.sub(Data_BigInt.ringBigInt);
var div1 = /* #__PURE__ */ Data_EuclideanRing.div(Data_BigInt.euclideanRingBigInt);
var StreamId = function (x) {
    return x;
};
var Speed = function (x) {
    return x;
};
var Bytes = function (x) {
    return x;
};
var Bits = function (x) {
    return x;
};
var showStreamId = Data_Show.showInt;
var showSpeed = Data_Show.showNumber;
var showBytes = Data_BigInt.showBigInt;
var showBits = Data_BigInt.showBigInt;
var semiringBytes = Data_BigInt.semiringBigInt;
var mul2 = /* #__PURE__ */ Data_Semiring.mul(semiringBytes);
var semigroupSpeed = {
    append: function (v) {
        return function (v1) {
            return v + v1;
        };
    }
};
var semigroupBytes = {
    append: function (v) {
        return function (v1) {
            return add1(v)(v1);
        };
    }
};
var semigroupBits = {
    append: function (v) {
        return function (v1) {
            return add1(v)(v1);
        };
    }
};
var ordStreamId = Data_Ord.ordInt;
var monoidSpeed = {
    mempty: 0.0,
    Semigroup0: function () {
        return semigroupSpeed;
    }
};
var mempty = /* #__PURE__ */ Data_Monoid.mempty(monoidSpeed);
var monoidBytes = {
    mempty: zero,
    Semigroup0: function () {
        return semigroupBytes;
    }
};
var monoidBits = {
    mempty: zero,
    Semigroup0: function () {
        return semigroupBits;
    }
};
var eqStreamId = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var eqSpeed = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordSpeed = {
    compare: function (x) {
        return function (y) {
            return compare(x)(y);
        };
    },
    Eq0: function () {
        return eqSpeed;
    }
};
var eqBytes = {
    eq: function (x) {
        return function (y) {
            return eq2(x)(y);
        };
    }
};
var ordBytes = {
    compare: function (x) {
        return function (y) {
            return compare1(x)(y);
        };
    },
    Eq0: function () {
        return eqBytes;
    }
};
var eqBits = {
    eq: function (x) {
        return function (y) {
            return eq2(x)(y);
        };
    }
};
var ordBits = {
    compare: function (x) {
        return function (y) {
            return compare1(x)(y);
        };
    },
    Eq0: function () {
        return eqBits;
    }
};
var encodeJsonStreamId = {
    encodeJson: /* #__PURE__ */ (function () {
        var $147 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
        var $148 = Data_Show.show(showStreamId);
        return function ($149) {
            return $147($148($149));
        };
    })()
};
var encodeJsonSpeed = Data_Argonaut_Encode_Class.encodeJsonJNumber;
var encodeJsonBytes = {
    encodeJson: /* #__PURE__ */ (function () {
        var $150 = Data_Argonaut_Encode_Class.encodeJson(MST_Encoding.encodeJsonEncDecWrapBigIn);
        return function ($151) {
            return $150(coerce($151));
        };
    })()
};
var encodeJsonBits = {
    encodeJson: function (v) {
        return encodeJson(Data_BigInt.toNumber(v));
    }
};
var decodeJsonStreamId = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (v) {
            var v1 = Data_Int.fromString(v);
            if (v1 instanceof Data_Maybe.Nothing) {
                return new Data_Either.Left(new Data_Argonaut_Decode_Error.UnexpectedValue(json));
            };
            if (v1 instanceof Data_Maybe.Just) {
                return new Data_Either.Right(v1.value0);
            };
            throw new Error("Failed pattern match at MST.Data.Units (line 165, column 5 - line 167, column 43): " + [ v1.constructor.name ]);
        });
    }
};
var decodeJsonSpeed = Data_Argonaut_Decode_Class.decodeJsonNumber;
var decodeJsonBytes = {
    decodeJson: /* #__PURE__ */ (function () {
        var $152 = Data_Argonaut_Decode_Class.decodeJson(MST_Encoding.decodeJsonEncDecWrapBigIn);
        return function ($153) {
            return coerce($152($153));
        };
    })()
};
var decodeJsonBits = {
    decodeJson: function (json) {
        return bind(decodeJson1(json))(function (num) {
            return coerce(Data_Either.note(new Data_Argonaut_Decode_Error.UnexpectedValue(json))(Data_BigInt.fromNumber(num)));
        });
    }
};
var arbitraryStreamId = Test_QuickCheck_Arbitrary.arbInt;
var arbitrarySpeed = Test_QuickCheck_Arbitrary.arbNumber;
var arbitraryBytes = {
    arbitrary: /* #__PURE__ */ mapFlipped(arbitrary)(function ($154) {
        return Bytes(Data_BigInt.fromInt($154));
    })
};
var arbitraryBits = {
    arbitrary: /* #__PURE__ */ mapFlipped(arbitrary)(function ($155) {
        return Bits(Data_BigInt.fromInt($155));
    })
};
var toBps = function (v) {
    return v * MST_Data_Time.nanosInSecond;
};
var kb1 = /* #__PURE__ */ Data_BigInt.fromInt(1024);
var mb1 = /* #__PURE__ */ mul2(kb1)(kb1);
var gb1 = /* #__PURE__ */ mul2(/* #__PURE__ */ mul2(kb1)(kb1))(kb1);
var gb2 = /* #__PURE__ */ Data_Semiring.add(semiringBytes)(gb1)(gb1);
var bytesToBits = function (v) {
    return mul1(v)(Data_BigInt.fromInt(8));
};
var bytesFromInt = function ($156) {
    return Bytes(Data_BigInt.fromInt($156));
};
var byteDiff = function (v) {
    return function (v1) {
        var $139 = greaterThanOrEq(v)(v1);
        if ($139) {
            return new Data_Maybe.Just(sub(v)(v1));
        };
        return Data_Maybe.Nothing.value;
    };
};
var bps = function (speed) {
    return speed / MST_Data_Time.nanosInSecond;
};
var bitsToBytes = function (v) {
    return div1(v)(Data_BigInt.fromInt(8));
};
var bitsPerDuration = function (dictPreciseDuration) {
    var toNano = MST_Data_Time.toNano(dictPreciseDuration);
    return function (v) {
        return function (duration) {
            var $143 = toNano(duration);
            var $144 = eq2($143)(zero);
            if ($144) {
                return mempty;
            };
            return Data_BigInt.toNumber(v) / Data_BigInt.toNumber($143);
        };
    };
};
var bytesPerDuration = function (dictPreciseDuration) {
    var bitsPerDuration1 = bitsPerDuration(dictPreciseDuration);
    return function (bytes) {
        return function (duration) {
            return bitsPerDuration1(bytesToBits(bytes))(duration);
        };
    };
};
var bitsInDuration = function (v) {
    return function (v1) {
        var precision = Data_Int.floor(MST_Data_Time.nanosInSecond);
        return div1(mul1(v1)(Data_Maybe.fromMaybe(zero)(Data_BigInt.fromNumber(Data_Number.floor(v * Data_Int.toNumber(precision))))))(Data_BigInt.fromInt(precision));
    };
};
var bytesInDuration = function (speed) {
    return function (duration) {
        return bitsToBytes(bitsInDuration(speed)(duration));
    };
};
var bitsFromInt = function ($157) {
    return Bits(Data_BigInt.fromInt($157));
};
export {
    Bits,
    Bytes,
    Speed,
    StreamId,
    bitsFromInt,
    bitsPerDuration,
    bitsToBytes,
    bps,
    byteDiff,
    bytesFromInt,
    bytesInDuration,
    bytesPerDuration,
    bytesToBits,
    gb1,
    gb2,
    kb1,
    mb1,
    toBps,
    eqBits,
    eqBytes,
    eqSpeed,
    eqStreamId,
    ordSpeed,
    ordBits,
    ordBytes,
    semigroupSpeed,
    monoidSpeed,
    semigroupBits,
    monoidBits,
    semigroupBytes,
    monoidBytes,
    showBits,
    showBytes,
    showSpeed,
    showStreamId,
    encodeJsonBits,
    decodeJsonBits,
    encodeJsonBytes,
    decodeJsonBytes,
    encodeJsonSpeed,
    decodeJsonSpeed,
    encodeJsonStreamId,
    decodeJsonStreamId,
    arbitraryStreamId,
    arbitrarySpeed,
    arbitraryBits,
    arbitraryBytes,
    ordStreamId,
    semiringBytes
};
